import {Component, computed, effect, input, output, signal} from '@angular/core';
import {AddressDTO} from "../../../interfaces";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-search-delivery',
    standalone: true,
    templateUrl: './search-delivery.component.html',
    imports: [FormsModule],
    styleUrl: './search-delivery.component.scss'
})
export class SearchDeliveryComponent {
    labelName = input<string>('Address');
    deliveredQty = input<number>(-1);
    addresses = input.required<AddressDTO[]>();
    addressId = input<number>(-1);

    isEmpty = output<boolean>();
    selectedAddress = output<number>();

    addressText = signal('');
    searchText = signal('');
    isListVisible = signal(false);

    options = computed(() => {
        return this.addresses().map((address) => ({
            id: address.addressId,
            text: this.processAddress(address),
            status: address.status
        }));
    });

    filteredOptions = computed(() => {
        const search = this.searchText().toLowerCase().trim();
        if (!search) {
            return this.options();
        }
        return this.options().filter(option =>
            option.text.toLowerCase().includes(search)
        );
    });

    constructor() {
        effect(() => {
            const id = this.addressId();
            const addresses = this.addresses();

            if (addresses.length === 1) {
                const singleAddress = addresses[0];
                this.selectedAddress.emit(singleAddress.addressId);
                this.addressText.set(this.processAddress(singleAddress));
                this.isEmpty.emit(false);
                this.isListVisible.set(false);
                return;
            }

            if (addresses.length === 0 || id <= 0) {
                this.addressText.set('');
                this.isListVisible.set(false);
                this.isEmpty.emit(true);
            } else {
                const address = this.options().find((addr) => addr.id === id);
                this.addressText.set(address ? address.text : '');
                this.isEmpty.emit(false);
            }
        });
    }

    processAddress(address: AddressDTO): string {
        let txt_address = '';
        if (address.addressLineOne?.trim()) {
            txt_address += `${address.addressLineOne.trim()}${address.addressLineOne.trim().endsWith(',') ? ' ' : ', '}`;
        }
        if (address.addressLineTwo?.trim()) {
            txt_address += `${address.addressLineTwo.trim()}${address.addressLineTwo.trim().endsWith(',') ? ' ' : ', '}`;
        }
        if (address.addressLineThree?.trim()) {
            txt_address += `${address.addressLineThree.trim()}${address.addressLineThree.trim().endsWith(',') ? ' ' : ', '}`;
        }
        if (address.city?.trim()) {
            txt_address += `${address.city.trim()}${address.city.trim().endsWith(',') ? ' ' : ', '}`;
        }
        if (address.country?.trim()) {
            txt_address += `${address.country.trim()}${address.country.trim() ? ' ' : ', '}`;
        }
        return txt_address.trim();
    }

    onOptionSelected(id: number): void {
        this.isListVisible.set(false);
        this.selectedAddress.emit(id);
        const address = this.options().find((addr) => addr.id === id);
        if (address) {
            this.addressText.set(address.text);
            this.searchText.set('');
        }
    }

    onInputChange(value: string): void {
        this.searchText.set(value);
        if (!this.isListVisible()) {
            this.isListVisible.set(true);
        }
    }

    onInputFocus(): void {
        if (!this.isDisabled()) {
            this.isListVisible.set(true);
            this.searchText.set(this.addressText());
        }
    }

    onInputBlur(): void {
        setTimeout(() => {
            this.isListVisible.set(false);
            if (this.searchText() && !this.addressText()) {
                this.searchText.set('');
            }
        }, 200);
    }

    isDisabled(): boolean {
        return !this.addresses().length;
    }
}